import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { GreenCheck2 } from "../Icons/GreenCheck2";
import { RedX } from "../Icons/RedX";
import { CtaWithReviews } from "../CtaWithReviews";
import { useSectionsData } from "../../utils/useSectionsData.ts";
import { getBrandName } from "../../utils/helpers.ts";
import glideImage from "../../utils/useGlideImage.ts";

export const Versus = () => {
  const sections = useSectionsData();
  const brandName = getBrandName();
  const staticContent = sections.pp_v7_static_content;
  const reviewCount = staticContent?.global_review_count;
  const starRating = staticContent?.global_star_rating;
  const comparison = sections.pp_v7_comparison_section;
  const heading = comparison.tr_heading;
  const subheading = comparison.tr_subheading;
  const productImage =
    comparison.product_image ||
    `${window.template_root}/v1/AshwagandhaProductImage.png`;
  const competitorsImage =
    comparison.competitors_image ||
    `${window.template_root}/v1/OtherSupplements.jpg`;
  const comparisonFacts = comparison.comparison_facts;

  return (
    <PageWrapper backgroundColor="section_white">
      <div className={s.versus}>
        <div
          className={s.versus__title}
          dangerouslySetInnerHTML={{ __html: heading }}
        ></div>
        {subheading && (
          <>
            <div className={s.versus__divider}></div>
            <div
              className={s.versus__subtitle}
              dangerouslySetInnerHTML={{ __html: subheading }}
            ></div>
          </>
        )}
        <div className={s.versus__imagesWrapper}>
          <img
            className={s.versus__orgImg}
            src={glideImage(productImage, { w: 400, h: 400 })}
            alt={brandName}
            width={400}
            height={400}
          />
          <div className={s.versus__vsCircle}>VS</div>
          <img
            src={glideImage(competitorsImage, { w: 400, h: 400 })}
            alt={brandName}
            width={400}
            height={400}
          />
        </div>
        {comparisonFacts.map(
          (
            item: { tr_org_text: string; tr_competitors_text: string },
            index: number
          ) => (
            <div className={s.versus__row} key={index}>
              <div className={s.versus__row__org}>
                <div>
                  <GreenCheck2 />
                </div>
                {item.tr_org_text}
              </div>
              <div className={s.versus__row__comp}>
                <div>
                  <RedX />
                </div>
                {item.tr_competitors_text}
              </div>
            </div>
          )
        )}
        <CtaWithReviews
          text={comparison.tr_cta_label}
          reviewslabel={staticContent.tr_reviews_label}
          reviewsCount={reviewCount}
          starsRating={starRating}
        />
      </div>
    </PageWrapper>
  );
};
